import { render, staticRenderFns } from "./ArticleHero.vue?vue&type=template&id=18dfd01a&scoped=true"
import script from "./ArticleHero.vue?vue&type=script&setup=true&lang=ts"
export * from "./ArticleHero.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./ArticleHero.vue?vue&type=style&index=0&id=18dfd01a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18dfd01a",
  null
  
)

export default component.exports